module.exports = __webpack_public_path__ + "img/contact6.0467fe73.png";